import React from 'react'

import { Form, Col } from '_zari/core'

const FechaEmisionFormGroup = ({ onChange, value }) => {
  return (
    <Form.Group>
      <Col md={12}>
        <Form.InputDate
          id='input-fechaEmision'
          placeholder='Ingresar fecha ...'
          onChange={onChange}
          value={value}
        />
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaEmisionFormGroup)
